var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "postit-note",
      class: ["postit-" + _vm.note.color, { dragging: _vm.isDragging }],
      style: { width: _vm.note.width + "px", height: _vm.note.height + "px" },
      attrs: { draggable: "true" },
      on: {
        dragstart: _vm.onDragStart,
        dragend: _vm.onDragEnd,
        click: _vm.onClick,
        dblclick: _vm.onDoubleClick,
        mouseenter: function ($event) {
          _vm.showControls = true
        },
        mouseleave: function ($event) {
          _vm.showControls = false
        },
      },
    },
    [
      _c("div", { staticClass: "postit-shadow" }),
      _vm._v(" "),
      _c("div", { staticClass: "postit-paper" }, [
        _vm._m(0),
        _vm._v(" "),
        _c("div", { staticClass: "postit-tape" }),
        _vm._v(" "),
        _c("div", { staticClass: "postit-content" }, [
          _vm.note.title
            ? _c("div", { staticClass: "postit-title" }, [
                _vm._v(_vm._s(_vm.note.title)),
              ])
            : _vm._e(),
          _vm._v(" "),
          _c("div", {
            staticClass: "postit-text",
            domProps: { innerHTML: _vm._s(_vm.formattedText) },
          }),
          _vm._v(" "),
          _c("div", { staticClass: "postit-date" }, [
            _vm._v(
              "\n        " +
                _vm._s(
                  _vm.formatDate(_vm.note.updatedAt || _vm.note.createdAt)
                ) +
                "\n      "
            ),
          ]),
        ]),
        _vm._v(" "),
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.showControls,
                expression: "showControls",
              },
            ],
            staticClass: "postit-controls",
          },
          [
            _c(
              "a-button",
              {
                staticClass: "control-btn edit-btn",
                attrs: { type: "link", size: "small" },
                on: {
                  click: function ($event) {
                    $event.stopPropagation()
                    return _vm.editNote.apply(null, arguments)
                  },
                },
              },
              [_c("a-icon", { attrs: { type: "edit" } })],
              1
            ),
            _vm._v(" "),
            _c(
              "a-button",
              {
                staticClass: "control-btn delete-btn",
                attrs: { type: "link", size: "small" },
                on: {
                  click: function ($event) {
                    $event.stopPropagation()
                    return _vm.deleteNote.apply(null, arguments)
                  },
                },
              },
              [_c("a-icon", { attrs: { type: "delete" } })],
              1
            ),
          ],
          1
        ),
        _vm._v(" "),
        _c("div", { staticClass: "postit-corner" }),
      ]),
    ]
  )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "postit-pin" }, [
      _c("div", { staticClass: "pin-head" }),
      _vm._v(" "),
      _c("div", { staticClass: "pin-needle" }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }